<template>
	<div id="file-type-not-supported-modal" class="modal-new hidden">
		<span class="title"> File Type Not Supported</span>
		<p class="description --text-left">The file you loaded seems to be unsupported. Please load a valid preset file in .json format</p>
		<div class="buttons-continer">
			<button @click="onConfirm" type="button" class="modal-btn --primary px-20">OK</button>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		onConfirm() {
			window.UI.hideModal();
			window.UI.showModal(window.UI.modals.presets.save.el);
		},
	},
};
</script>

<style></style>
